<mat-toolbar color="primary">
  <h1>Micro Frontend - VDC Guia de Diseño</h1>
</mat-toolbar>

<mat-sidenav-container fullscreen class="sidenav-container">
  <mat-sidenav class="sidenav" mode="side" [opened]="true">
    <mat-nav-list>
      <a mat-list-item [routerLink]="item.url" *ngFor="let item of menu">{{
        item.name
      }}</a>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content>
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
